/* eslint-disable import/no-cycle */
import React, { memo } from 'react';

import Modal from 'components/modal/modal';
import { Button, TextBox } from 'components';
import { useModalCustomerEdit } from 'domains/quotation/hooks/use-modal-customer-edit';
import './modal-edit-customer-info.scss';
import SpinnerCar from 'components/spinner/spinner-car/spinner-car';

type Props = {
  isOpen: any;
  handleClose: any;
};

const ModalEditCustomerInfo: React.FC<Props> = ({
  handleClose,
  isOpen,
}: Props) => {
  const {
    fields,
    changeValidState,
    formValid,
    handleBtnClick,
    handleChange,
    spinner,
    handleClickClose,
  } = useModalCustomerEdit({ handleClose, isOpen });

  return (
    <div className="new-customer-modal modal-edit-customer">
      <Modal onClose={handleClickClose} hasClose={true} isOpen={isOpen}>
        <div>
          <h1 className="new-customer-modal__title">Actualicemos tus datos</h1>

          <div className="modal-personal-info__form">
            <TextBox
              type="tel"
              id="phone"
              label="Número de celular"
              placeholder="999 999 999"
              onChange={(e: any) => handleChange(e, 'phone')}
              value={fields.phone}
              validators={[
                { exp: 'required', msg: 'Debe completar este campo' },
                {
                  exp: /^9\d{8}$/,
                  msg: 'El número debe iniciar con 9 y tener 9 dígitos',
                },
              ]}
              onValidState={(valid: boolean) => {
                changeValidState('phoneValid', valid);
              }}
              cleaveOptions={{
                options: {
                  blocks: [3, 3, 3],
                },
              }}
            />

            <TextBox
              type="text"
              id="email"
              label="Correo Electrónico"
              placeholder="ejemplo@correo.com"
              onChange={(e: any) => handleChange(e, 'email')}
              value={fields.email}
              validators={[
                { exp: 'required', msg: 'Debe completar este campo' },
                {
                  exp: /^[\w_\-.]+@([\w-]+\.)+[\w-]{2,4}$/,
                  msg: 'Ingresa un correo electrónico válido',
                },
              ]}
              onValidState={(valid: boolean) => {
                changeValidState('emailValid', valid);
              }}
            />
          </div>

          <div className="new-customer-modal__button-container">
            <Button
              label="Continuar"
              disabled={!formValid}
              onClick={handleBtnClick}
            />
          </div>

          <SpinnerCar
            show={spinner}
            title="Un momento por favor"
            text="Estamos actualizando los datos de tu plan"
          />
        </div>
      </Modal>
    </div>
  );
};
export default memo(ModalEditCustomerInfo);
